import { useEffect, useState } from 'react';
import firebase from '../firebaseConfig';

// Returns 'public' | 'inviteOnly' | 'private' for a project or track target.
// Server is authoritative — `links/global/settings/access mode` directly
// stores all three values (see SHARING_MODEL.md §1).
export function useShareDisplayMode(target) {
    const [mode, setMode] = useState('private');

    useEffect(() => {
        if (!target?.artistId || !target?.projectId) return;
        const base = firebase.database()
            .ref('artists').child(target.artistId)
            .child('projects').child(target.projectId);
        const ref = target.kind === 'track' && target.trackId
            ? base.child('tracks').child(target.trackId)
                .child('links').child('global').child('settings').child('access mode')
            : base.child('links').child('global').child('settings').child('access mode');
        const handler = ref.on('value', (snap) => {
            const v = snap.val();
            setMode(v === 'public' || v === 'inviteOnly' ? v : 'private');
        });
        return () => ref.off('value', handler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target?.kind, target?.artistId, target?.projectId, target?.trackId]);

    return mode;
}
